import { render, staticRenderFns } from "./GridRoutes.vue?vue&type=template&id=19154d10&"
import script from "./GridRoutes.vue?vue&type=script&lang=js&"
export * from "./GridRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19154d10')) {
      api.createRecord('19154d10', component.options)
    } else {
      api.reload('19154d10', component.options)
    }
    module.hot.accept("./GridRoutes.vue?vue&type=template&id=19154d10&", function () {
      api.rerender('19154d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routes/grid/GridRoutes.vue"
export default component.exports